const DocumentEventCollectionFields = [
	{
		ID: "CreatedOn",
		Label: "Created On",
	},
];

export default DocumentEventCollectionFields;